export default __webpack_public_path__ + "static/our_promise-a1559aeed10671197479e30f7dba333e.jpg";